export default {
  getCurrentPageData(fullData, dataPerPage, page) {
    let start = dataPerPage * (page - 1);
    let end = dataPerPage * page;
    if (end > fullData.length) {
      end = fullData.length;
    }
    return fullData.slice(start, end);
  },
  getStartCount(page, dataPerPage) {
    return (page - 1) * dataPerPage;
  },
  getSortColumn(sortBy) {
    return sortBy.length > 0 ? sortBy[0].key : "";
  },
  generateSortByObject(key, order = "asc") {
    return [{ key: key, order: order }];
  },
  filterSelected(selectedInner, items, identifierProperty, selectedItems) {
    //required becos of https://github.com/vuetifyjs/vuetify/issues/18151
    if (selectedInner.length === 0) {
      selectedItems.splice(0, selectedItems.length);
      return;
    }
    items.forEach((item) => {
      const identifier = item[identifierProperty];
      const isInSelectedAlrdy =
        selectedItems.filter((selected) => {
          const selectedIdentifier = selected[identifierProperty];
          return identifier == selectedIdentifier;
        }).length > 0;
      const isInSelectedCurrently = selectedInner.includes(identifier);
      if (isInSelectedCurrently && !isInSelectedAlrdy) {
        //NEWLY SELECTED
        selectedItems.push(item);
      } else if (!isInSelectedCurrently && isInSelectedAlrdy) {
        //REMOVE ITEM
        const removeIndex = selectedItems.findIndex((selected) => {
          const selectedIdentifier = selected[identifierProperty];
          return identifier == selectedIdentifier;
        });
        selectedItems.splice(removeIndex, 1);
      }
    });
  },
  generateCustomSortObject(headers) {
    let customSort = {};
    headers.forEach((header) => {
      if (header.sort) {
        customSort[header.key] = header.sort;
      }
    });
    return customSort;
  },
};
